import { useAPIContext } from "context/APIContext";
import { useErrorMessageContext } from "context/ErrorModalContext";
import { useFeedbackContext } from "context/FeedbackContext";
import { useFeedbackModalCardContext } from "context/FeedbackModalCardContext";
import { useKEAGraphContext } from "context/KEAGraphContext";
import { dimension, useWindowSizeContext, windowPadding } from "context/WindowSizeContext";
import { useEffect, useState } from "react";
import { ContentContainer } from "shared/ContentContainer";
import { FeedbackMessage } from "tasks/sample_feedback";
import { ContentView } from "./content/ContentView";

interface Props {}

export const FeedbackEditor = (_props: Props) => {
  const windowSizeContext = useWindowSizeContext();
  const apiContext = useAPIContext();
  const feedbackContext = useFeedbackContext();
  const feedbackModalContext = useFeedbackModalCardContext();
  const keaGraphContext = useKEAGraphContext();
  const errorModalContext = useErrorMessageContext();

  const [contentDimension, setContentDimension] = useState<dimension>({
    width: 1,
    height: 1,
  });

  useEffect(() => {
    setContentDimension({
      width: 1,
      height: windowSizeContext.dimension.height - windowPadding,
    });
  }, [windowSizeContext.dimension.height]);

  const updateFeedback = async (id: string) => {
    const apiFeedbacks = await apiContext.apiManager.getAssessmentsForSubmissionExercise(id);
    let feedbacks: { [id: string]: Array<FeedbackMessage> } = {};
    let unresolvedFeedbacks: Array<FeedbackMessage> = [];
    let positionFeedback: Array<FeedbackMessage> = [];

    apiFeedbacks.forEach((item: FeedbackMessage) => {
      if (typeof item.position === "string") {
        if (!feedbacks[item.position]) {
          feedbacks[item.position] = [];
        }
        const newFeedack = feedbacks[item.position];
        newFeedack.push(item);
        feedbacks[item.position] = newFeedack;
      }
      if (typeof item.position === "object") {
        if (item.position.x && item.position.y) {
          positionFeedback.push(item);
        }
      }
      if (typeof item.position === "undefined") {
        unresolvedFeedbacks.push(item);
      }
    });
    feedbackContext.setFeedback(feedbacks);
    feedbackContext.setUnresolvedFeedback(unresolvedFeedbacks);
    feedbackContext.setPositionFeedback(positionFeedback);
  };

  return (
    <>
      <ContentContainer width={windowSizeContext.dimension.width} height={contentDimension.height}>
        <ContentView
          apiManager={apiContext.apiManager}
          setFeedback={feedbackContext.setFeedback}
          setPositionFeedback={feedbackContext.setPositionFeedback}
          setUnresolvedFeedback={feedbackContext.setUnresolvedFeedback}
          positionFeedback={feedbackContext.positionFeedback}
          updateFeedback={updateFeedback}
          setNode={feedbackModalContext.setNode}
          width={windowSizeContext.dimension.width}
          height={contentDimension.height}
          modelingGraph={keaGraphContext.modelingGraph}
          modelingPaper={keaGraphContext.modelingPaper}
          feedback={feedbackContext.feedback}
          unresolvedFeedback={feedbackContext.unresolvedFeedback}
          toggleErrorModal={errorModalContext.toggleErrorModal}
          addUserInteraction={keaGraphContext.addUserInteraction}
          keaGraphContext={keaGraphContext}
        />
      </ContentContainer>
    </>
  );
};
